import React from 'react'
import { Typography } from '@material-ui/core'
import { Email, Sms, Notifications, Group } from '@material-ui/icons'
import secondsToTimeUnits from 'utils/secondsToTimeUnits'
import language from 'utils/vast-languagepack'

// classes.expandPanelIconTypography,
// classes.expandPanelIconInner,

export default (task, classes) => {
  switch (task.task_type_id) {
    case '1':
      return {
        icon: (
          <div className={classes.expandPanelIconInner}>
            <Email />
            <Typography className={classes.expandPanelIconTypography}>
              {language.task.add.types.email}
            </Typography>
          </div>
        ),
        scheduled:
          task.send_email && task.send_email.when_to_send ? (
            <span>
              <span style={{ marginLeft: 15 }}>Scheduled: </span>
              <span className={classes.createdDate}>
                {new Date(task.send_email.when_to_send).toLocaleDateString()}
              </span>
            </span>
          ) : task.send_email.delay_seconds ? (
            <span>
              <span style={{ marginLeft: 15 }}>Delay: </span>
              <span className={classes.createdDate}>
                {secondsToTimeUnits(task.send_email.delay_seconds)}
              </span>
            </span>
          ) : null,
      }
    case '2':
      return {
        icon: (
          <div className={classes.expandPanelIconInner}>
            <Sms />
            <Typography className={classes.expandPanelIconTypography}>
              {language.task.add.types.sms}
            </Typography>
          </div>
        ),
        scheduled:
          task.send_sms && task.send_sms.when_to_send ? (
            <span>
              <span style={{ marginLeft: 15 }}>Scheduled: </span>
              <span className={classes.createdDate}>
                {new Date(task.send_sms.when_to_send).toLocaleDateString()}
              </span>
            </span>
          ) : task.send_sms.delay_seconds ? (
            <span>
              <span style={{ marginLeft: 15 }}>Delay: </span>
              <span className={classes.createdDate}>
                {secondsToTimeUnits(task.send_sms.delay_seconds)}
              </span>
            </span>
          ) : null,
      }
    case '3':
      return {
        icon: (
          <div className={classes.expandPanelIconInner}>
            <Notifications />
            <Typography className={classes.expandPanelIconTypography}>
              {language.task.add.types.notifications}
            </Typography>
          </div>
        ),
      }
    case '4':
      return {
        icon: (
          <div className={classes.expandPanelIconInner}>
            <Group />
            <Typography className={classes.expandPanelIconTypography}>
              {language.task.add.types.addContactsGroup}
            </Typography>
          </div>
        ),
        scheduled:
          task.add_contacts_to_group &&
          task.add_contacts_to_group.when_to_trigger ? (
            <span>
              <span style={{ marginLeft: 15 }}>{language.task.add.types.scheduledHeading} </span>
              <span className={classes.createdDate}>
                {new Date(
                  task.add_contacts_to_group.when_to_trigger,
                ).toLocaleDateString()}
              </span>
            </span>
          ) : task.add_contacts_to_group.delay_seconds ? (
            <span>
              <span style={{ marginLeft: 15 }}>{language.task.add.types.delayHeading} </span>
              <span className={classes.createdDate}>
                {secondsToTimeUnits(task.add_contacts_to_group.delay_seconds)}
              </span>
            </span>
          ) : null,
      }
    case '5':
      return {
        icon: (
          <div className={classes.expandPanelIconInner}>
            <Group />
            <Typography className={classes.expandPanelIconTypography}>
              {language.task.add.types.removeContactsGroup}
            </Typography>
          </div>
        ),
        scheduled:
          task.remove_contacts_from_group &&
          task.remove_contacts_from_group.when_to_trigger ? (
            <span>
              <span style={{ marginLeft: 15 }}>{language.task.add.types.scheduledHeading} </span>
              <span className={classes.createdDate}>
                {new Date(
                  task.remove_contacts_from_group.when_to_trigger,
                ).toLocaleDateString()}
              </span>
            </span>
          ) : task.remove_contacts_from_group.delay_seconds ? (
            <span>
              <span style={{ marginLeft: 15 }}>{language.task.add.types.delayHeading} </span>
              <span className={classes.createdDate}>
                {secondsToTimeUnits(
                  task.remove_contacts_from_group.delay_seconds,
                )}
              </span>
            </span>
          ) : null,
      }
    case '6':
      return {
        icon: (
          <div className={classes.expandPanelIconInner}>
            <Group />
            <Typography className={classes.expandPanelIconTypography}>
              {language.task.add.types.contactBetweenGroups}
            </Typography>
          </div>
        ),
        scheduled:
          task.move_contacts_btwn_groups &&
          task.move_contacts_btwn_groups.when_to_trigger ? (
            <span>
              <span style={{ marginLeft: 15 }}>{language.task.add.types.scheduledHeading} </span>
              <span className={classes.createdDate}>
                {new Date(
                  task.move_contacts_btwn_groups.when_to_trigger,
                ).toLocaleDateString()}
              </span>
            </span>
          ) : task.move_contacts_btwn_groups.delay_seconds ? (
            <span>
              <span style={{ marginLeft: 15 }}>{language.task.add.types.delayHeading} </span>
              <span className={classes.createdDate}>
                {secondsToTimeUnits(
                  task.move_contacts_btwn_groups.delay_seconds,
                )}
              </span>
            </span>
          ) : null,
      }
    default:
      return null
  }
}
